// extracted by mini-css-extract-plugin
export default {"whiteBlockLeft":"WhiteBlocks_whiteBlockLeft__aXYRN","whiteBlockRight":"WhiteBlocks_whiteBlockRight__b6hf0","whiteBlockLeftGray":"WhiteBlocks_whiteBlockLeftGray__QxAZ0"};